import Immutable from "immutable";
import { floatToMoney } from "lib/money";

import * as studentLinked from "lib/appserver/entityHeaders/studentLinked";

const DinnerHistoryItem = new Immutable.Record({
  description: undefined,
  startDate: undefined,
  endDate: undefined,
  booking: undefined,
  totalPrice: undefined,
  ...studentLinked.defaultProperties
}, "Dinner History Item");

function buildDinnerHistoryItemFromAppserver(rawHistoryItem) {
  const rawDinnerHistoryItem = rawHistoryItem.payload;
  // TODO: fix this on the server end (hopefully?)
  rawHistoryItem.student_fk = rawDinnerHistoryItem.student_fk;
  return DinnerHistoryItem({
    description: rawDinnerHistoryItem.payment_description,
    startDate: rawDinnerHistoryItem.dinner_start_date,
    endDate: rawDinnerHistoryItem.dinner_end_date,
    totalPrice: floatToMoney(rawDinnerHistoryItem.weekly_total),
    booking: buildBookingfromAppserver(rawDinnerHistoryItem),
    ...studentLinked.appserverAdapter(rawHistoryItem)
  })
}

function buildBookingfromAppserver(rawDinnerHistoryItem) {
  const bookings = new Immutable.List([
    rawDinnerHistoryItem.monday_booking,
    rawDinnerHistoryItem.tuesday_booking,
    rawDinnerHistoryItem.wednesday_booking,
    rawDinnerHistoryItem.thursday_booking,
    rawDinnerHistoryItem.friday_booking,
  ]);
  // TODO more processing needed here?
  return bookings;
}

DinnerHistoryItem.fromAppserver = buildDinnerHistoryItemFromAppserver;
export default DinnerHistoryItem;



// WEBPACK FOOTER //
// ./src/state/school_money/entities/DinnerHistoryItem.js